// extracted by mini-css-extract-plugin
module.exports = {"container":"ActivityDetails_container__3yOtn","title":"ActivityDetails_title__1vMF4","cell":"ActivityDetails_cell__2pEG6"};